export const getSourceApplicationUrl = () => {
  const rootPath = window.location.pathname.split('/')[1];
  return `${window.location.origin}/${rootPath}`;
};
